<div class="page">
    
    <div class="page-name">Manage Production Entity</div><br>

        <div class="title-list-sec">
            <dx-data-grid 
                    #prodEntityGrid
                    id="prodEntityGrid"
                    class="grid-with-header manage-prod-entity"
                    [dataSource]="prodEntityList" 
                    [allowColumnResizing]="true" 
                    [columnResizingMode]="'widget'" 
                    [showColumnLines]="true"
                    [showBorders]="true" 
                    [hoverStateEnabled]="true" 
                    [rowAlternationEnabled]="true"
                    [columnAutoWidth]="true" 
                    (onRowRemoving)="onProdEntityRowRemoving($event)"
                    (onRowUpdated)="updateProdEntity($event)"
                    >
                    <dxo-filter-row [visible]="true"></dxo-filter-row>

                    <dxo-editing mode="row" [allowDeleting]="allowProdEntityDelete" 
                    [allowUpdating]="allowProdEntityUpdate" [useIcons]="true"></dxo-editing>

                    <dxi-column caption="PRODUCTION ENTITY" dataField="entityDescription" width="25%"></dxi-column>
                    <dxi-column caption="ASSOCIATED PROJECTS" dataField="projectTitle" dataType="string" [allowEditing]="false" width="60%"></dxi-column>
                    <dxi-column caption="STATUS" dataField="isDelete" dataType="boolean" [allowEditing]="allowProdEntityUpdate" width="10%">
                     <dxo-lookup 
                     [dataSource]="deleteStatusOptions" 
                     valueExpr="value" 
                     displayExpr="name">
                   </dxo-lookup></dxi-column>
        
            </dx-data-grid>
        </div>
    </div>
    <app-confirmation-popup *ngIf="openConfirmationPopup" [option]="confirmationPopupOption"
    (onConfirmed)="confirmationChanges($event)"></app-confirmation-popup>

    <app-load-panel *ngIf="showLoadPanel" [option]="loadPanelOption"></app-load-panel>